import { render, staticRenderFns } from "./SocialLoginPage.vue?vue&type=template&id=7633ccf4&scoped=true"
import script from "./SocialLoginPage.vue?vue&type=script&lang=js"
export * from "./SocialLoginPage.vue?vue&type=script&lang=js"
import style0 from "./SocialLoginPage.vue?vue&type=style&index=0&id=7633ccf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633ccf4",
  null
  
)

export default component.exports